import { useSuspenseQuery } from '@apollo/client';
import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { FC, PropsWithChildren } from 'react';
import { gql } from '@/__generated__';
import { OnboardingLinkPage } from '@/__generated__/graphql.ts';
import { Link } from '@/routes-utils/navigation.tsx';

const stripeOnboardingUrlQuery = gql(`
  query stripeOnboardingUrlQuery($page: OnboardingLinkPage, $queryParams: String) {
    me {
      protectedFields {
        stripeExpressSellerAccount {
          onboardingUrl(page: $page, queryParams: $queryParams)
        }
      }
    }
  }
`);

interface StripeOnboardingLinkProps {
  variant: 'link' | 'button';
  redirectTo: OnboardingLinkPage;
}

export const StripeOnboardingLink: FC<
  PropsWithChildren<StripeOnboardingLinkProps>
> = ({ children, variant, redirectTo }) => {
  const isTablet = useIsTablet();

  const { data } = useSuspenseQuery(stripeOnboardingUrlQuery, {
    fetchPolicy: 'no-cache',
    variables: {
      page: redirectTo,
      queryParams: 'stripeDetailsSubmitted=true',
    },
  });
  const onboardingUrl =
    data?.me?.protectedFields?.stripeExpressSellerAccount?.onboardingUrl;

  if (!onboardingUrl) {
    return null;
  }
  return variant === 'button' ? (
    <Button size={isTablet ? 'large' : 'medium'} asChild>
      <Link to={onboardingUrl} target={'_blank'}>
        {children}
      </Link>
    </Button>
  ) : (
    <Link to={onboardingUrl} target={'_blank'}>
      {children}
    </Link>
  );
};
